import getMessageList from "./getMessageList";
import createMessage from "./createMessage";
import getMessageDetail from "./getMessageDetail";
import getWhatsappTemplateDetail from "./getWhatsappTemplateDetail";
import createWhatsappTemplate from "./createWhatsappTemplate";
import updateWhatsappTemplate from "./updateWhatsappTemplate";
import getBranches from "./getBranches";
import updateMessage from "./updateMessage";
import createWhatsappMessageTemplate from "./createWhatsappMessageTemplate";
import optionWhatsappMessageTemplate from "./optionWhatsappMessageTemplate";
import getWhatsappMessageTemplateList from "./getWhatsappMessageTemplateList";
import getWhatsappMessageTemplateDetail from "./getWhatsappMessageTemplateDetail";
import updateWhatsappMessageTemplate from "./updateWhatsappMessageTemplate";
import createAudience from "./createAudience";
import getProducts from "./getProducts";
import getAudienceDetail from "./getAudienceDetail";
import updateAudience from "./updateAudience";
import getAudienceGroup from "./getAudienceGroup";
import deleteWhatsappMessageTemplate from "./deleteWhatsappMessageTemplate";
import uploadHeaderImage from "./uploadHeaderImage";
import cancelBlasting from "./cancelBlasting";
import syncWhatsappMessageTemplate from "./syncWhatsappMessageTemplate";
import deleteBlasting from "./deleteBlasting";
import getAudienceDataList from "./getAudienceDataList";
import hasAudience from "./hasAudience";
import getMessageBlastHistory from "./getMessageBlastHistory";
import getTemplateAnalytic from "./getTemplateAnalytic";
import getTemplatePerformanceAnalytic from "./getTemplatePerformanceAnalytic";
import syncAnalytics from "./syncAnalytics";
import getLocationSearch from "./getLocationSearch";
import otpReport from "./otpReport";
import totalSpentReport from "./totalSpentReport";

const messageApi = {
  getMessageList,
  createMessage,
  getMessageDetail,
  getWhatsappTemplateDetail,
  createWhatsappTemplate,
  updateWhatsappTemplate,
  getBranches,
  updateMessage,
  createWhatsappMessageTemplate,
  optionWhatsappMessageTemplate,
  getWhatsappMessageTemplateList,
  getWhatsappMessageTemplateDetail,
  createAudience,
  getProducts,
  getAudienceDetail,
  updateAudience,
  getAudienceGroup,
  updateWhatsappMessageTemplate,
  deleteWhatsappMessageTemplate,
  uploadHeaderImage,
  cancelBlasting,
  syncWhatsappMessageTemplate,
  deleteBlasting,
  getAudienceDataList,
  hasAudience,
  getMessageBlastHistory,
  getTemplateAnalytic,
  getTemplatePerformanceAnalytic,
  syncAnalytics,
  getLocationSearch,
  otpReport,
  totalSpentReport
};

export default messageApi;
